import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import cn from 'classnames';

import { childrenShape } from '@bibliocommons/bc-prop-types';

import './ModalContent.scss';

export default function ModalContent({ className, children, dataKey }) {
  const contentRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const contentEl = contentRef.current;
    if (!contentEl) {
      return undefined;
    }

    const handleScroll = throttle(
      () => {
        setIsScrolled(contentEl.scrollTop > 1);
      },
      50,
      { leading: true, trailing: true }
    );

    contentEl.addEventListener('scroll', handleScroll);

    return () => {
      contentEl.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const classNames = cn('cp-modal-content', className, {
    'modal-content--scrolled': isScrolled
  });

  return (
    <div className={classNames} data-key={dataKey} ref={contentRef}>
      {children}
    </div>
  );
}

ModalContent.propTypes = {
  className: PropTypes.string,
  children: childrenShape,
  dataKey: PropTypes.string
};
